export default __webpack_public_path__ + "static/media/vc.007dc890.svg";